import { render, staticRenderFns } from "./HighlightedDashboard.vue?vue&type=template&id=64795d84&scoped=true"
import script from "./HighlightedDashboard.vue?vue&type=script&lang=ts"
export * from "./HighlightedDashboard.vue?vue&type=script&lang=ts"
import style0 from "./HighlightedDashboard.vue?vue&type=style&index=0&id=64795d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64795d84",
  null
  
)

export default component.exports